export default "/fonts/vendor/katex/dist/KaTeX_AMS-Regular.woff2?73ea273a72f4aca30ca528cf9117470a";